<template>
  <div class="posterDetail">
    <div class="img_box">
      <van-image width="100%" height="100%" fit="contain" rel="external nofollow" v-show="loadShow" :src="imgUrl" />
      <div class="desc">
        <img src="../../assets/images/pun-left.png" alt="" class="left_img" />
        <img src="../../assets/images/pun-rig.png" alt="" class="right_img" />
        <span>{{ desc }}</span>
      </div>
    </div>
    <van-row>
      <!-- <van-col span="12">
        <van-button :icon="require('../../assets/images/down.png')" type="info" @click="save">保存海报</van-button>
      </van-col> -->
      <van-col span="24">
        <div class="tip">长按保存海报~</div>
        <van-button class="my-button" type="primary" @click="copy">复制文案</van-button>
      </van-col>
    </van-row>

    <!--<img class="store" :src="posterUrl" alt="" />-->
  </div>
</template>

<script>
import { Toast, Notify } from "vant";
import { createPlaybill } from "@/server/api.js";
import html2canvas from "html2canvas";
import { wefunstatistics } from "@/utils/public";
export default {
  name: "posterDetail",
  data() {
    return {
      imgUrl: "",
      desc: "",
      posterUrl: "",
      userId: "HuangLiJie",
      loadShow: false,
    };
  },
  mounted() {
    this.desc = this.$route.query.desc;
    wefunstatistics("4", window.location.href.split("#")[0]);
    this.creatPoster();
  },
  methods: {
    //生成海报
    async creatPoster() {
      let params = {
        id: this.$route.query.id,
        userId: this.$route.query.userId,
        // userId:'HuangLiJie'
      };
      const res = await createPlaybill(params);
      if (res.code !== "200") return Toast.fail(res.msg);
      //console.log(res)
      this.imgUrl = res.data.activityBill;
      this.loadShow = true;
      // this.imgUrl = "http://qfzy.static.1000phone.net/img/2022-06-23/9685701443557A72F513CAE93527C21C.jpg";
    },

    save(downloadURL) {
      let that = this;
      that.isshow = !that.isshow;
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "正在合成海报",
      });
      setTimeout(() => {
        // DOM节点主体
        let main = document.getElementById("imageWrapper");
        // context.scale(1, 1);
        //useCORS允许网络地址图片跨域
        html2canvas(main, {
          //dpi: window.devicePixelRatio * 2,
          width: parseInt(main.offsetWidth),
          height: parseInt(main.offsetHeight),
          scale: 2,
          useCORS: true,
        }).then((canvas) => {
          var dataUrl = canvas.toDataURL("image/png", 1.0);
          console.log(dataUrl);
          // that.posterUrl = dataUrl;
          Toast.clear();
          Toast("生成成功,请长按保存");

          let link = document.createElement("a");
          link.href = canvas.toDataURL(); //下载链接
          link.setAttribute("download", "111");
          link.style.display = "none"; //a标签隐藏
          document.body.appendChild(link);
          link.click();
        });
      }, 1500);
      // downloadURL = 'http://qfzs.static.1000phone.net/img/2021-02-02/763da35ba52e1f01c85b2399f765a59c.jpg'
      // let blob=new Blob([''], {type:'application/octet-stream'});
      // let url = URL.createObjectURL(blob);
      // let a = document.createElement('a');
      // a.href = downloadURL;
      // a.download = downloadURL.replace(/(.*\/)*([^.]+.*)/ig,"$2").split("?")[0];
      // let e = document.createEvent('MouseEvents');
      // e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      // a.dispatchEvent(e);
      // URL.revokeObjectURL(url);
    },
    copy() {
      if (!this.desc) return Toast.fail("未上传文案");
      let oInput = document.createElement("input");
      oInput.value = this.desc;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      // Toast.success("复制成功");
      Notify({
        type: "success",
        duration: 1000,
        message: "文案已复制", // （文案来源为的描述信息）
      });
      oInput.remove();
    },
  },
};
</script>

<style lang="less" scoped>
.posterDetail {
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  padding: 12px 0 20px;
  background-color: #f6f6f6;
  /deep/ .van-nav-bar {
    line-height: 100px;
    .van-nav-bar__content {
      height: 100px;
      .van-nav-bar__left,
      .van-nav-bar__right {
        font-size: 30px;
        .van-nav-bar__arrow {
          font-size: 46px;
        }
      }
      .van-nav-bar__title {
        font-size: 30px;
      }
    }
    .van-image {
      width: 42px;
      height: 42px;
    }
  }
  /deep/ .van-col {
    text-align: center;
  }
  /deep/.van-button {
    width: 230px;
    height: 46px;
    background-color: #267df0;
    color: #ffffff;
    font-size: 20px;
    text-align: center;
    border-radius: 6px;
    border: none;
    &.my-button {
      // background: linear-gradient(to right, #ff4b56, #ff848c);
    }
  }
  .tip {
    //position: absolute;
    //bottom: 0px;
    //left: 0px;
    width: 100%;
    height: 40px;
    color: red;
    font-size: 28px;
    line-height: 40px;
    text-align: center;
    margin-bottom: 20px;
  }
}

.img_box {
  width: 675px;
  box-sizing: border-box;
  position: relative;
  box-sizing: border-box;
  padding: 10px 0 20px;
  margin: 0 auto 50px;
  text-align: center;
  .van-image {
    margin: 5px auto !important;
    width: 675px;
    height: 1460px;
    border-radius: 8px;
    overflow: hidden;
    .van-image__img {
    }
  }
  .desc {
    padding: 30px 32px;
    line-height: 50px;
    text-align: left;
    color: #333;
    font-size: 34px;
    font-weight: 500;
    position: relative;
    background-color: #f3f3f3;
    border-radius: 6px;
    img {
      width: 20px;
      position: absolute;
    }
    .left_img {
      top: 18px;
      left: 12px;
    }
    .right_img {
      bottom: 18px;
      right: 12px;
    }
    span {
      font-size: 26px;
    }
  }
}
</style>
